export class InitStartup {
  static readonly type = '[Startup] Init startup';
  constructor(public isSignedIn: boolean, public isDisabled: boolean | null) {}
}
